import Vue from 'vue';
import VueRouter from 'vue-router';
import { TokenService } from './services/storage.service'

// Pages
import Dash from "./pages/DashVue";
import Products from "./pages/ProductsVue";
import Login from "./pages/Login";
import Register from "./pages/Register";

Vue.use(VueRouter);

// Routes
const routes = [
    { 
      path: '/', 
      name: 'Dashboard', 
      component: Dash 
    },
    { 
      path: '/Products', 
      name: 'Products Management', 
      component: Products 
    },
    { 
      path: '/Login', 
      name: 'Login', 
      component: Login, 
      meta: {
        public: true,  // Allow access to even if not logged in
        onlyWhenLoggedOut: true
      }
    },
    { 
      path: '/Register', 
      name: 'Register', 
      component: Register,
      meta: {
        public: true,  // Allow access to even if not logged in
        onlyWhenLoggedOut: true
      }
    },
    // otherwise redirect to home
    { path: '*', redirect: '/' }
];

const router = new VueRouter({
    routes // short for `routes: routes`
});

router.beforeEach((to, from, next) => {
    const isPublic = to.matched.some(record => record.meta.public)
    const onlyWhenLoggedOut = to.matched.some(record => record.meta.onlyWhenLoggedOut)
    const loggedIn = !!TokenService.getToken();

    if (!isPublic && !loggedIn) {
        return next({
        path:'/login',
        query: {redirect: to.fullPath}  // Store the full path to redirect the user to after login
        });
    }

    // Do not allow user to visit login page or register page if they are logged in
    if (loggedIn && onlyWhenLoggedOut) {
        return next('/')
    }

    next();
});

export default router;